module.exports = __webpack_public_path__ + "public/media/marketeer.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer.png
// module id = ./images/services/marketeer.png
// module chunks = 0